'use client'

import { useMemo, useState } from 'react'

import Icon, { IconName, PhosphorIconName } from '@/components/atomic/icon'

/**
 * @deprecated Use `Copy` from `@moment/design-system-ui/copy` instead.
 */
function ClickToCopy({
  children,
  value,
}: {
  children: React.ReactNode
  value: string
}) {
  const [showCopiedText, setShowCopiedText] = useState(false)

  const onClick = useMemo(() => {
    return () => {
      navigator.clipboard.writeText(value)
      setShowCopiedText(true)
      setTimeout(() => {
        setShowCopiedText(false)
      }, 1000)
    }
  }, [value])

  const onKeyDown = useMemo(() => {
    return (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (e.key === 'Enter') {
        onClick()
      }
    }
  }, [onClick])

  return (
    // biome-ignore lint/a11y/useSemanticElements: Bulk suppression as part of biome migration
    <div
      className="flex items-center gap-1 cursor-pointer"
      onClick={onClick}
      onKeyDown={onKeyDown}
      role="button"
      tabIndex={0}
    >
      {children}
      {showCopiedText ? (
        <Icon
          iconName={IconName.CheckIcon}
          outline
          className="w-4 h-4 text-secondary"
        />
      ) : (
        <Icon
          iconName={PhosphorIconName.CopyIcon}
          outline
          className="w-4 h-4 text-secondary"
          isPhosphor
        />
      )}
    </div>
  )
}

// biome-ignore lint/style/noDefaultExport: Existing default export — prefer named exports for new code
export default ClickToCopy
